module.exports = __webpack_public_path__ + "img/1m.8aac387a.png";